import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  PutDocumentsQueueRequestType,
  PutDocumentsQueueResponseType,
} from '../types';

export const putDocumentsQueue = async (
  params: PutDocumentsQueueRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/queue`;
  const response = await apiAuthClient.put<PutDocumentsQueueResponseType>(
    url,
    params.documentQueue,
  );

  return response.data;
};
